module.exports = __webpack_public_path__ + "media/images/riders/small/MAJA_WLOSZCZOWSKA-c585c826056c02e291228f8658b1a7a1.png";